export const environment = {
  production: true,
  apiUrl: '/',

};



// WEBPACK FOOTER //
// /build/client-cms/src/environments/environment.ts